import PropTypes from 'prop-types';
import { Component } from 'react';
import { DEFAULT_REGISTRY } from '../../utils/defaults';
import { getDefaultValue } from '../../utils/additionalPropertyUtils';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import UnderConstruction from '../../../Doc/components/UnderConstruction';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import TextInput from '../inputs/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class StringField extends Component {
  constructor(...args) {
    super(...args);
    this.getPlaceholder = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        isAdditionalProperty,
        placeholder
      } = this.props;
      if (placeholder !== undefined) {
        return placeholder;
      }
      if (isAdditionalProperty) {
        return getDefaultValue('string');
      }
      return null;
    };
  }
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      autoFocus,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      collapsed,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      isAdditionalProperty,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onChange,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry = DEFAULT_REGISTRY,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema
    } = this.props;
    const {
      title,
      format
    } = schema;
    const {
      formContext
    } = registry;
    if (format) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: `StringField: ${format}`
      });
    }
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(TextInput
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        autoFocus: autoFocus,
        formContext: formContext,
        id: idSchema && idSchema.$id,
        disabled: disabled,
        label: title || name,
        onChange: onChange,
        placeholder: this.getPlaceholder(),
        readOnly: readOnly,
        required: required,
        schema: schema,
        value: formData || ''
      })
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
StringField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
StringField.defaultProps = {
  disabled: false,
  readOnly: false
};